<template>
    <step-container>
        <product-info class="cz3__hide-lg" />

        <step-info
            class="cz3__hide-sm"
            :label="$t('V3_CUSTOMIZATION_TYPE')"
        />

        <form-fields role="group">
            <form-fields-main-scroll>
                <div class="cz3__small-header">{{$t('V3_GROUP_HEADER')}}</div>

                <div>
                    <fake-radio-button
                        :selected="!isGroup"
                        :label="$t('V3_GROUP_INDIVIDUAL')"
                        @select="selectIndividual"
                    />
                </div>

                <div class="cz3__help-text cz3__help-text--pull-up">
                    {{$t('V3_SINGLE_INFO')}}
                </div>

                <div>
                    <fake-radio-button
                        :selected="isGroup"
                        :label="$t('V3_GROUP_TITLE')"
                        @select="selectGroup"
                    />
                </div>

                <div class="cz3__help-text cz3__help-text--pull-up">
                    {{$t('V3_GROUP_INFO')}}
                </div>
            </form-fields-main-scroll>

            <step-buttons>
                <action-button
                    class="cz3__flex-1"
                    :label="$t('V3_GET_STARTED')"
                    @click="getStarted"
                />
            </step-buttons>
        </form-fields>
    </step-container>
</template>

<script>
    import StepContainer from './StepContainer.vue';
    import ProductInfo from './ProductInfo.vue';
    import FormFields from './FormFields.vue';
    import FakeRadioButton from './FakeRadioButton.vue';
    import ActionButton from './ActionButton.vue';
    import StepButtons from './StepButtons.vue';
    import StepInfo from './StepInfo.vue';
    import FormFieldsMainScroll from './FormFieldsMainScroll.vue';

    export default {
        components: {
            StepContainer,
            ProductInfo,
            FormFields,
            FakeRadioButton,
            ActionButton,
            StepButtons,
            StepInfo,
            FormFieldsMainScroll,
        },

        data() {
            return {
                isGroup: false,
            };
        },

        computed: {
            nextStep() {
                return this.$store.getters.nextStepV3;
            },
        },

        mounted() {
            this.$store.dispatch('lockSwipe', false);
        },

        methods: {
            selectIndividual() {
                this.isGroup = false;
            },

            selectGroup() {
                this.isGroup = true;
            },

            getStarted() {
                if (this.isGroup) {
                    this.$store.dispatch('setAppVersion', '1');
                    this.$store.dispatch('setIsGroupOrder', true);
                    this.$store.dispatch('closeMobileOrderTypePrompt');

                    this.$nextTick(() => {
                        // Reset scroll position.
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    });
                } else {
                    this.$store.dispatch('setIsGroupOrder', false);

                    this.$store.dispatch('setSelectedStepV3', this.nextStep);
                }
            },
        },
    };
</script>
